import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../assets/img/Icons/stage-checkmark-icon.svg'
import _imports_1 from '@/assets/img/Icons/iconRight.svg'


const _hoisted_1 = { class: "new_client" }
const _hoisted_2 = { class: "identification_box" }
const _hoisted_3 = { class: "identification_list" }
const _hoisted_4 = { class: "checked" }
const _hoisted_5 = { href: "#" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "cheked_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_7 = { class: "active" }
const _hoisted_8 = { href: "#" }
const _hoisted_9 = { href: "#" }
const _hoisted_10 = { class: "form_box" }
const _hoisted_11 = {
  "data-toggle": "validator",
  role: "form",
  "data-lng": "ru"
}
const _hoisted_12 = { class: "field_wrapper" }
const _hoisted_13 = { class: "field_box" }
const _hoisted_14 = { class: "field form-group" }
const _hoisted_15 = { class: "title_box" }
const _hoisted_16 = { class: "field form-group" }
const _hoisted_17 = {
  for: "country_field",
  style: { marginBottom: '14px' }
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "help-block with-errors" }, null, -1)
const _hoisted_19 = { class: "field form-group" }
const _hoisted_20 = { class: "field form-group" }
const _hoisted_21 = { class: "field form-group" }
const _hoisted_22 = {
  for: "name_field",
  style: { marginBottom: '14px' }
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "help-block with-errors" }, null, -1)
const _hoisted_24 = { class: "field form-group" }
const _hoisted_25 = { class: "title_box" }
const _hoisted_26 = { class: "field form-group" }
const _hoisted_27 = {
  for: "country_field",
  style: { marginBottom: '14px' }
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "help-block with-errors" }, null, -1)
const _hoisted_29 = { class: "field form-group" }
const _hoisted_30 = { class: "field form-group" }
const _hoisted_31 = { class: "field form-group" }
const _hoisted_32 = { class: "field form-group" }
const _hoisted_33 = { class: "director_file_adding mb-4 d-flex" }
const _hoisted_34 = { class: "director_file_adding d-flex" }
const _hoisted_35 = { class: "error" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_select_country = _resolveComponent("ui-select-country")!
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_date_picker = _resolveComponent("ui-date-picker")!
  const _component_ui_company_document_file = _resolveComponent("ui-company-document-file")!
  const _component_ui_company_document_adding_btn = _resolveComponent("ui-company-document-adding-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.profile.FirstName) + " " + _toDisplayString(_ctx.profile.SecondName), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("PersonalInformation")) + " ", 1),
            _hoisted_6
          ])
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$localization.getTranslate("Identification")), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$localization.getTranslate("Liveness")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$localization.getTranslate("Passport")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$localization.getTranslate("PassportCountryCode")), 1),
              _createVNode(_component_ui_select_country, {
                onChange: _ctx.selectPassportCountryCode,
                modelValue: _ctx.State,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.State) = $event))
              }, null, 8, ["onChange", "modelValue"]),
              _hoisted_18
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.PassportNumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.PassportNumber) = $event)),
                headerText: _ctx.$localization.getTranslate('PassportNumber'),
                warningMsg: _ctx.$localization.getTranslate('FillThisField'),
                required: ""
              }, null, 8, ["modelValue", "headerText", "warningMsg"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.PassportIssuedBy,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.PassportIssuedBy) = $event)),
                headerText: _ctx.$localization.getTranslate('PassportIssuedBy'),
                warningMsg: _ctx.$localization.getTranslate('FillThisField'),
                required: ""
              }, null, 8, ["modelValue", "headerText", "warningMsg"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$localization.getTranslate("PassportIssuedDate")), 1),
              _createVNode(_component_ui_date_picker, {
                style: { 'max-width': `280px` },
                modelValue: _ctx.PassportIssuedDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.PassportIssuedDate) = $event)),
                dateFormat: "DD-MM-YYYY"
              }, null, 8, ["modelValue"]),
              _hoisted_23
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$localization.getTranslate("RegistrationAddress")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$localization.getTranslate("Country")), 1),
              _createVNode(_component_ui_select_country, {
                onChange: _ctx.selectCountryCode,
                modelValue: _ctx.country,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.country) = $event))
              }, null, 8, ["onChange", "modelValue"]),
              _hoisted_28
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.State1,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.State1) = $event)),
                headerText: _ctx.$localization.getTranslate('State'),
                warningMsg: _ctx.$localization.getTranslate('FillThisField'),
                required: ""
              }, null, 8, ["modelValue", "headerText", "warningMsg"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.City,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.City) = $event)),
                headerText: _ctx.$localization.getTranslate('City'),
                warningMsg: _ctx.$localization.getTranslate('FillThisField'),
                required: ""
              }, null, 8, ["modelValue", "headerText", "warningMsg"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.Street,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.Street) = $event)),
                headerText: _ctx.$localization.getTranslate('Street'),
                warningMsg: _ctx.$localization.getTranslate('FillThisField'),
                required: ""
              }, null, 8, ["modelValue", "headerText", "warningMsg"])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_ui_input, {
                modelValue: _ctx.IndexCode,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.IndexCode) = $event)),
                headerText: _ctx.$localization.getTranslate('Index'),
                warningMsg: _ctx.$localization.getTranslate('FillThisField'),
                required: ""
              }, null, 8, ["modelValue", "headerText", "warningMsg"])
            ]),
            _createElementVNode("div", _hoisted_33, [
              (_ctx.ScanPassport?.FileName && _ctx.ScanPassport?.FileBase64)
                ? (_openBlock(), _createBlock(_component_ui_company_document_file, {
                    key: 0,
                    fileName: _ctx.ScanPassport?.FileName,
                    onDeleteFile: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteFile(_ctx.ScanPassport)))
                  }, null, 8, ["fileName"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ui_company_document_adding_btn, {
                buttonColor: "#8e97a1",
                buttonText: 
									_ctx.ScanPassport?.FileName
										? `${_ctx.$localization.getTranslate(
												'Identification.EditCompanyDocumentBtn'
										  )}`
										: `${_ctx.$localization.getTranslate('DownloadPassportScan')}`
								,
                isWrong: !(_ctx.ScanPassport?.FileName && _ctx.ScanPassport?.FileBase64),
                onAddedFile: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onAddScan(true, $event)))
              }, null, 8, ["buttonText", "isWrong"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              (_ctx.ScanUtilityBill?.FileName && _ctx.ScanUtilityBill?.FileBase64)
                ? (_openBlock(), _createBlock(_component_ui_company_document_file, {
                    key: 0,
                    fileName: _ctx.ScanUtilityBill?.FileName,
                    onDeleteFile: _cache[11] || (_cache[11] = ($event: any) => (_ctx.deleteFile(_ctx.ScanUtilityBill)))
                  }, null, 8, ["fileName"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ui_company_document_adding_btn, {
                buttonColor: "#8e97a1",
                buttonText: 
									_ctx.ScanUtilityBill?.FileName
										? `${_ctx.$localization.getTranslate(
												'Identification.EditCompanyDocumentBtn'
										  )}`
										: `${_ctx.$localization.getTranslate('DownloadUtilityBill')}`
								,
                isWrong: !(_ctx.ScanUtilityBill?.FileName && _ctx.ScanUtilityBill?.FileBase64),
                onAddedFile: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onAddScan(false, $event)))
              }, null, 8, ["buttonText", "isWrong"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.ErrorMessage), 1),
        _createElementVNode("button", {
          class: "ui_continue_button",
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.GoNext && _ctx.GoNext(...args))),
          disabled: !_ctx.Validation()
        }, [
          _hoisted_37,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Continue")), 1)
        ], 8, _hoisted_36)
      ])
    ])
  ]))
}